export { useVocabSelection } from './useVocabSelection';
export type {
  VocabSelection,
  VocabSelectionActions,
} from './useVocabSelection';

// Re-export types for convenience
export type { IVocabObj } from '@/entities/vocabulary';
